import { ArrowDownIcon } from 'icons'
import {
    Component,
    createSignal,
    For,
    onCleanup,
    onMount,
    Show,
} from 'solid-js'

import './style/dropdown.scss'

type itemType = {
    name: string
    value: string
}
interface dropdownProps {
    class?: string
    onchange: (value: string) => void
    active: string
    items: itemType[]

    blur?: boolean
    maxHeight?: number
}
const Dropdown: Component<dropdownProps> = P => {
    const [active, setActive] = createSignal(false)

    let ref: HTMLElement
    let itemsRef: HTMLDivElement

    const closeOnOutsideClick = (e: MouseEvent) => {
        if (ref && !ref.contains(e.target as Node)) {
            close()
        }
    }

    onMount(() => {
        if (P.blur) {
            ref.addEventListener('blur', close)
            onCleanup(() => {
                ref.removeEventListener('blur', close)
            })
        }

        document.addEventListener('click', closeOnOutsideClick, {
            passive: true,
        })

        onCleanup(() => {
            document.removeEventListener('click', closeOnOutsideClick)
        })
    })

    function close() {
        setActive(false)

        if (itemsRef) itemsRef.style.maxHeight = `0`
    }

    const toggle = () => {
        setActive(s => {
            let now = !s

            if (itemsRef) {
                if (now) {
                    itemsRef.style.maxHeight = `${P.maxHeight || itemsRef.scrollHeight}px`
                } else {
                    itemsRef.style.maxHeight = `0`
                }
            }

            return now
        })
    }

    return (
        <div
            class={`dropdown ${P.class || ''}`}
            classList={{ active: active() }}
            ref={e => (ref = e)}
        >
            <button
                type='button'
                class='active-wrapper title_smaller'
                onclick={toggle}
            >
                <span>{P.active}</span>
                <ArrowDownIcon />
            </button>
            <div class='items-wrapper' ref={e => (itemsRef = e)}>
                <Show when={P.items}>
                    <For each={P.items}>
                        {item => (
                            <button
                                type='button'
                                class='item title_smaller'
                                onclick={() => {
                                    P.onchange(item.value)
                                    close()
                                }}
                            >
                                {item.name}
                            </button>
                        )}
                    </For>
                </Show>
            </div>
        </div>
    )
}

export default Dropdown
